<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  .settings-page {
    display: flex;
    flex-direction: column;
    padding: utils.in_rem(4px) 0;
    align-self: stretch;
    align-items: flex-start;

    .header {
      h2 {
        @include colors.color(primary_50);
      }

      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .content-wrapper {
      width: 100%;
      max-width: 600px;
      display: flex;
      flex-direction: column;
      gap: utils.in_rem(16px);
      margin-top: utils.in_rem(16px);
    }
  }
</style>

<script>
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import TextInput from "@sourcewhale/shared/svelte-design-system/components/molecules/InputFields/TextInput.svelte";
  import { teamStore } from "../../../api-stores/meetings-store";
  import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store";
  import { adminModify } from "../../../api/admin";
  import { createInboxAgentAdminContext } from "./InboxAgent/context";

  const { aiDraftFAQStore } = createInboxAgentAdminContext();
  const { dirty } = aiDraftFAQStore;
  const { meta } = teamStore;

  let disabled = $derived(!$dirty || $meta.fetching || !$meta.firstFetchDone);

  const onclick = async () => {
    await adminModify({
      kind: "set-team-inbox-agent-draft-ai-faq",
      data: {
        value: JSON.stringify($aiDraftFAQStore),
        userId: $userStore.userId,
      },
    });
    await teamStore.get();
  };
  teamStore.once();
</script>

<div class="settings-page">
  <div class="header">
    <h2>SourceWhale AI</h2>
    <Button
      leadingIcon="fa-save"
      kind="primary"
      size="small"
      {onclick}
      {disabled}
      class={disabled ? "disabled" : ""}>Save</Button
    >
  </div>
  <p>
    Provide any information you'd like our AI to know when generating content
    for your team.
  </p>
  <div class="content-wrapper">
    <TextInput
      kind="textarea"
      label="Company Info"
      bind:value={$aiDraftFAQStore.companyInfo}
      placeholder="Share a concise description of your company - what you do, who you help, your unique edge."
    />
    <TextInput
      kind="textarea"
      label="Testimonials"
      bind:value={$aiDraftFAQStore.testimonials}
      placeholder="Add names of clients you've worked with, standout success stories, or quotes from hiring managers and candidates."
    />
    <TextInput
      kind="textarea"
      label="Additional information"
      bind:value={$aiDraftFAQStore.otherInfo}
      placeholder="Include extra information on topics your team is asked about frequently, e.g. your fee structure, time-to-hire etc."
    />
  </div>
</div>
